import SyncStatus from '../enums/sync-status';

interface SyncDetails {
  fieldKey: string;
  lastSyncTime: string | null;
  syncStatus: string;
}

export default SyncDetails;

export const isSyncDetailsInstance = (input: any): input is SyncDetails => {
  return 'fieldKey' in input && 'lastSyncTime' in input && 'syncStatus' in input;
};

// mock data

export const mockSyncDetails: SyncDetails = {
  fieldKey: 'some field key',
  lastSyncTime: '2024-09-08T23:59:99',
  syncStatus: SyncStatus.SUCCEEDED,
};
